<template>
  <!-- eslint-disable vue/no-v-html -->
  <label
    :class="context.classes.label"
    :for="context.id"
    v-html="context.label"
  />
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: 'HtmlLabel',
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
};
</script>
